import { observer } from 'mobx-react-lite';
import { FC, useRef } from 'react';

import { ImageCropper, IImageCropperHandlers, TImageCropperType } from '@gem/components';
import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';
import { Button, PopupFooter } from '@gem/ui-kit';

import { useImageCropperPopupPresenter } from './ImageCropperPopup.presenter';
import styles from './ImageCropperPopup.styles.m.css';

interface IImageCropperPopupProps {
  image: string;
  type: TImageCropperType;
  onChange(url: string): void;
}

export const ImageCropperPopup: FC<ICommonPopupsProps<IImageCropperPopupProps>> = observer(
  ({ popupInstance, params }) => {
    const { t } = useTranslation();
    const { type, image, onChange } = params!;

    const cropperRef = useRef<IImageCropperHandlers>(null);

    const presenter = useImageCropperPopupPresenter({
      onChange,
      onClose: popupInstance.close,
      cropperRef,
    });

    return (
      <Popup
        title={t('change_profile_photo_pop_up_title')}
        isOpened
        overlayClassName={styles.overlay}
        onClose={popupInstance.close}
      >
        <ImageCropper
          ref={cropperRef}
          image={image}
          type={type}
          onError={presenter.onError}
        />
        <PopupFooter>
          <Button
            onClick={presenter.handleUploadImage}
            isDisabled={presenter.isLoading}
            isLoading={presenter.isLoading}
            theme="primary"
          >
            {t('profile_photo_apply_button')}
          </Button>
        </PopupFooter>
      </Popup>
    );
  }
);
